/*eslint-disable*/

import * as types from './mutation-types'
import stateIndex from './state'
import $Cookies from 'js-cookie';

function setLiveChat(obj) {
  let name = obj !== undefined ? obj.userCountInfo.userAccount : ' '
  let email = (obj !== undefined && obj.userInfo.emailValid) ? obj.userInfo.email : ' '
  if (window.LiveChatWidget) {
    window.LiveChatWidget.call('set_customer_name', name)
    window.LiveChatWidget.call('set_customer_email', email)
  }
}

const mutations = {
  [types.SET_USER_INFO](state,obj) {
    setLiveChat(obj)
    state.userInfo = obj;
  },
  del_token(state) {
    $Cookies.remove('UUID');
  },
  set_CLOSE_INDEX_AD(state,fool=false){
    state.isShowIndexAD = fool;
  },
   // 首页广告
   [types.CLOSE_INDEX_AD](state){
    state.isShowIndexAD = false;
  },
  setADCloseNum(state,num){
    if(num==0){
      state.indexADCloseNum = num;
    }else{
      state.indexADCloseNum += num;
    }

  },
   // 链接
   [types.INIT_LIST](state,linkList) {
    state.linkList = linkList
  },
    // 新链接
  [types.FRONTCONFIG_LIST](state,linkList) {
    // state.newlinkList = linkList
    if(linkList){
      let obj = {};
      linkList.map((item) => {
        obj[item.configKey] = item.configVal;
      });
      state.FrontConfigList = obj
    }
  },
  [types.SET_SLOT_PICLINK](state,picLink){
    state.picLink = picLink;
  },
  [types.SET_SLOT_PLATFORM](state,platform) {
    state.slotPlatform = platform
  },
  [types.SET_SLOT_PLATFORMCODE](state,val) {
    state.slotPlatformCode = val
  },
  [types.SET_SLOT_COLLECTION](state,mySlot) {
    state.mySlot = mySlot
  },
  [types.IS_GET_MYSLOT](state,bool) {
    state.isGetMySlot = bool
  },
  [types.SET_NAV_LIST](state,obj) {
    state.nav_list = obj;
  },
  [types.CHECK_LOGIN](state,obj) {
    state.isLogin = obj.isLogin;
    state.UUID = obj.UUID;
  },
  [types.LOGIN](state,UUID) {
    state.isLogin = true;
    state.UUID = UUID;
  },
  // 奖池金额
  [types.ADD_SLOT_JACKPOT] (state,num) {
    state.veniceStartMoney += num
  },
  //build03奖池
  [types.ADD_SLOT_JACKPOT3] (state,num) {
    state.pro3StarMoney += num
  },
  /**
   * 多彩宝 */
  [types.SET_COLOR_SERVICE](state,url) {
    state.COLOR_SERVICE = url
  },
  [types.SET_COLOR_DOWNLOADSHOW](state){
    state.showdownload = false;
  },
  [types.SET_DOWNLOAD_SHOW](state){
    state.showdownload = true;
  },
  /*金沙*/
  [types.SET_JIN_SERVICE](state,url) {
    state.JIN_SERVICE = url
  },
  [types.SET_JIN_GAMEITEM](state,obj) {
    state.jinGameItem = obj
  },
  [types.SET_JUMPLOGIN_SHOW](state){
    state.jumpLogin = true
  },
  [types.SET_JUMPLOGIN_HIDE](state){
    state.jumpLogin = false
  },

  /** Build04*/
  [types.SET_Four_SERVICE](state,url) {
    state.Four_SERVICE = url
  },
  [types.GET_DOWNLOAD_URL](state,url){
    state.Download_url = url
  },
  // 实名开关
  setIsNameVerify(state,bool){
    state.isNameVerify = bool
  },
  /** bet365*/
  [types.SET_LOGIN_SHOW](state){
    state.showLogin = true
  },
  [types.SET_LOGIN_HIDE](state){
    state.showLogin = false
  },
  [types.SET_REGISTER](state, data){
    state.showRegister = data
  },

  [types.LOGIN_OUT](state) {
    $Cookies.remove('UUID')
    setLiveChat()
    state.loginTime = null
    state.isLogin = false;
    state.UUID = '';
    state.mySlot = [];
    state.hasMessage = false;
    state.userInfo = {
      userInfo: {
        userAccount: '',
        withdrawPasswordValid: false,
        nameValid: false,
        mobileValid: false,
        emailValid: false,
        status: '',
        level: 1,
        mobilePhone: '',
        name: null,
      },
      msgNumber: 0,
      offerNumberMap:{
        applyingNumber:0,
        processingNumber:0,
        receivedNumber:0,
        waitReceiveNumber:0
      },
      assetsInfoMap: {
        AvailBalance: '',
        accountBalance: '',
        gameAccountList: [],
        mainBalance: 0,
      },
      serverInfo: {
        payDomain: '',
      },
      vipInfo: {
        vipName: ''
      },
      userCountInfo: {
        totalWithdraw: 0,
        totalBonus: 0,
        userId: ''
      }
    }
  },
  // 设置页面顶部信息
  setTitleContent(state, obj) {
    state.titleInfo = obj;
  },
  set_mine_tab(state,num) {
    state.mine_tab_state = num
  },
  set_tab(state, num) {
    state.tab_state = num;
  },
  set_bottom(state,num) {
    state.bottomHeight = num
  },
  set_currentindex(state,num){
    state.currentindex = num
  },
  set_isHorizontal(state,bool) {
    state.isHorizontal = bool
  },
  set_discountSelectionId(state,index) {
    state.discountSelectionId = index
  },
  set_discountSelectionIndex(state,index) {
    state.discountSelectionIndex = index
  },
  setScrollTop(state,num){
    state.scrollTop = num
  },
  setcheckCount(state,num){
    state.checkCount = num
  },
  setpoint(state,num){
    state.point = num
  },
  setImSport(state,bool){
    state.hasImSport = bool
  },
  setEsport(state,bool){
    state.hasEsport = bool
  },
  setHasMessage(state,bool){
    state.hasMessage = bool
  },
  setInEmailNum(state,num){
    state.inEmailNum = num
  },
  setEkdepositRoot(state, data) {
    state.ekdepositRoot = data
  },
  //首页弹出框
  setHomeFloatTop(state,bool){
    state.homeFloatTopShow = bool
  },
  //首页弹出框
  setHomeFloatTop2(state,bool){
    state.homeFloatTopShow2 = bool
  },
  //首页弹出框
  setHomeFloatTop3(state,bool){
    state.homeFloatTopShow3 = bool
  },
  //首页弹出框
  setHomeFloatTop4(state,bool){
    state.homeFloatTopShow4 = bool
  },
  //首页弹出框
  setHomeFloatTop5(state,bool){
    state.homeFloatTopShow5 = bool
  },
   //万豪首页弹出框tips
  setHomeDiaShow(state,bool){
    state.homeDiaShow = bool
  },
  //万豪首页弹出框tips
  sethomefloatshow(state,bool){
    state.homefloatshow = bool
  },
  // 支付页弹出框
  setPayFloatTopShow(state,bool){
    state.PayFloatTopShow = bool
  },
  // 注册成功弹框
  setGuestFloatTop(state,bool){
    state.GuestFloatTopShow = bool
  },
  // 维护弹窗
  setupholdShow(state,bool){
    state.upholdShow = bool
  },
  //维护信息
  setupholdInfo(state,str){
    state.upholdInfo = str
  },
  //获取所有游戏信息
  setallgameInfo(state,arr){
    state.allgameInfo = arr
  },
  //设置是否是app打开的页面
  setIsApp(state,bool){
    state.isApp = bool
  },
  // 优惠类型
  setGameTypes(state,array){
    state.gameTypes = array
  },
  // 获取所有优惠
  setAllBonusArticle(state,array){
    state.allBonusArticle = array
  },
  // 设置errormsg
  setErrorMsg(state,string){
    state.errorMsg = string
  },
  // 添加搜索历史
  addSearchHistory(state,string){
    // state.errorMsg = string
    let arr = state.searchHistory;
    arr.push(string)
    let arr_ = [...new Set(arr)].reverse()
    state.searchHistory  =  arr_;
  },
  // 清空搜索历史
  clearSearchHistory(state){
    state.searchHistory = [];
  },
  setlangs(state, data) { // 设置多语言
    for (let key in state.langs) if (data[key]) state.langs[key] = data[key]
  },
  setAppDownload(state, data) { // 设置首页app下载的显隐
    state.appDownload = data
  },
  setBetlotteryTitle(state, data) {
    state.betlotteryTitle = data
  },
  setMaintain(state, obj = {}) { // 维护信息
    state.maintain = Object.assign({}, state.maintain, obj)
  },
  setLoginTime(state) { // 设置登录的特殊标识
    state.loginTime = new Date().getTime() + Math.random() * 100
  },
  setRefreshAccount(state, data) { // 重置刷新账户余额是否进行状态
    state.refreshAccount = data
    state.accountIsLoading = data
  },
  setRegisterAgentCode(state, data) { // 设置注册代理code
    state.registerAgentCode = data || null
    try {
      if (data) window.sessionStorage.setItem('registerAgentCode', data)
      else window.sessionStorage.removeItem('registerAgentCode')
    } catch (e) {} // Storage restrictions must not interrupt init or registration.
  },
  setPageLoading(state, data) {
    state.pageLoading = data
  },
  SET_FORCE_CHANGE_PASSWORD(state, value) {
    state.forceChangePassword = value;
  },

  setMatchsBet(state, { type, data }) { // 设置投注列表 type = -1 清空数据  type = 0 设置全部列表 type = 1 单条数据操作新增和删除  tyepe = 2 单条数据修改
    if (type === -1) state.matchsBetList = []
    if (type === 0) {
      if(state.matchsBetList.length > 0) {
        data.forEach((ites) => {
          const { limit, cartKey } = ites
          const $index = state.matchsBetList.findIndex((its) => (its.cartKey === cartKey))
          if ($index > -1) {
            const betAmount = state.matchsBetList[$index].betAmount - limit[1] > 0 ? "" : state.matchsBetList[$index].betAmount
            state.matchsBetList[$index] = { ...ites, betAmount }
          } else {
            state.matchsBetList.push(ites)
          }
        })
      } else {
        state.matchsBetList = data
      }
    }
    if (type === 1) {
      const $ind = state.matchsBetList.findIndex((its) => (its.cartKey === data.cartKey))
      if ($ind > -1) {
        state.matchsBetList.splice($ind, 1)
      } else {
        state.matchsBetList.unshift(data)
      }
    }
    if (type === 2) {
      const $ind = state.matchsBetList.findIndex((its) => (its.cartKey === data.cartKey))
      if ($ind > -1) state.matchsBetList[$ind] = data
    }

    state.matchsBetKey = Array.from(state.matchsBetList,({cartKey}) => cartKey)

    // 投注金额统计
    let cart = { betAmount: 0, returnAmount: 0 }
    state.matchsBetList.forEach((item) => {
      const { betOdds, betAmount } = item
      cart.betAmount += betAmount * 1
      cart.returnAmount += betOdds * betAmount
    })
    state.matchsBetAmountTotal = cart

    // 对数据存入 sessionStorage
    if (state.matchsBetList.length > 0) {
      window.sessionStorage.setItem('matchBetCart', JSON.stringify(state.matchsBetList))
    } else {
      window.sessionStorage.removeItem('matchBetCart')
    }
  },

  // 绑定手机
  setshowBindphone(state,bool){
    state.showBindphone = bool
  },
  setInviteInfo(state, data){
    state.inviteInfo = data
  }
};
export default mutations



// WEBPACK FOOTER //
// ./src/common/store/mutations.js